
import { FC } from 'react'

import {
  AcceptButton,
  SparkleIcon,
  SuggestedContainer,
  SuggestedLabel,
  SuggestedText,
  SuggestedValue,
  TextContainer,
} from './styled'

import AIStartIconPng from '../../../../../../assets/icons/iaStar.png'

interface SuggestedDominanceProps {
  suggestedDominance: string
  onAccept: () => void
}

const dominanceMapping: { [key: string]: string } = {
  FI: 'Frontal Izquierdo (FI)',
  FD: 'Frontal Derecho (FD)',
  BI: 'Basal Izquierdo (BI)',
  BD: 'Basal Derecho (BD)',
}

const SuggestedDominance: FC<SuggestedDominanceProps> = ({ suggestedDominance, onAccept }) => {
  const fullDominance = dominanceMapping[suggestedDominance] || suggestedDominance

  return (
    <SuggestedContainer>
      <TextContainer>
        <SparkleIcon>
          <img src={AIStartIconPng} alt="AI Start" />
        </SparkleIcon>
        <SuggestedText>
          <SuggestedLabel>Dominancia sugerida:</SuggestedLabel>
          <SuggestedValue>{fullDominance}</SuggestedValue>
        </SuggestedText>
      </TextContainer>
      <AcceptButton onClick={onAccept}>Aceptar sugerencia</AcceptButton>
    </SuggestedContainer>
  )
}

export default SuggestedDominance
